import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class BrandService extends GenericService {
  constructor() {
    super('/brands', axiosInstance);
  }
}

export default new BrandService(); 